// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"defs","attrs":{},"children":[{"tag":"mask","attrs":{"id":"props.overlapMaskId_fill1","maskUnits":"userSpaceOnUse","maskContentUnits":"userSpaceOnUse","mask-type":"luminance","x":"0","y":"0","width":"24","height":"24"},"children":[{"tag":"rect","attrs":{"x":"0","y":"0","width":"24","height":"24","fill":"#fff"}},{"tag":"path","attrs":{"stroke":"#000","d":"M16.5 18V6M7.75 17.25L13 12L7.75 6.75V17.25Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth","fill":"none"}}]}]},{"tag":"g","attrs":{"id":"next"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M13 12L7.75 17.25V6.75L13 12Z","mask":"props.overlapMaskUrl_fill1"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M16.5 18V6M7.75 17.25L13 12L7.75 6.75V17.25Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const NextIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'next',
    ref,
    icon: element,
  },
));

NextIcon.displayName = 'NextIcon';

export default NextIcon;
